(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["la-rose-features"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('la-rose-features-slider')) {
  customElements.define('la-rose-features-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.track = this.querySelector('.la-features__container');
      this.items = [...this.querySelectorAll('.la-features__item')];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.interacting = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1), opts);
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1), opts);
      this.querySelector('[data-pause]')?.addEventListener('click', (event) => {
        this.paused = !this.paused;
        event.currentTarget.setAttribute('aria-pressed', String(this.paused));
        event.currentTarget.setAttribute('aria-label', this.paused ? 'Resume automatic sliding' : 'Pause automatic sliding');
        event.currentTarget.textContent = this.paused ? '▶' : 'Ⅱ';
        this.schedule();
      }, opts);
      this.addEventListener('pointerenter', (e) => { if(e.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, opts);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, opts);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, opts);
      this.addEventListener('focusout', (e) => { this.focused = this.contains(e.relatedTarget); this.schedule(); }, opts);
      this.track.addEventListener('pointerdown', () => { this.interacting = true; this.schedule(); }, opts);
      const release = () => { if(this.interacting) { this.interacting = false; this.schedule(); } };
      window.addEventListener('pointerup', release, opts);
      window.addEventListener('pointercancel', release, opts);
      this.track.addEventListener('scroll', () => this.schedule(), { ...opts, passive:true });
      this.track.addEventListener('keydown', (e) => {
        if(e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); this.move(e.key === 'ArrowRight' ? 1 : -1); }
      }, opts);
      document.addEventListener('visibilitychange', () => this.schedule(), opts);
      this.motion.addEventListener('change', () => this.schedule(), opts);
      document.addEventListener('shopify:block:select', (e) => {
        const item = e.target.closest('.la-features__item');
        if(item && this.contains(item)) {
          this.paused = true;
          this.schedule();
          this.track.scrollTo({ left:this.position(item), behavior:'auto' });
        }
      }, opts);
      this.resize = new ResizeObserver(() => {
        this.querySelector('.la-features__controls').hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
        this.schedule();
      });
      this.resize.observe(this.track);
      this.schedule();
    }
    position(item) {
      return item.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
    }
    move(direction) {
      const max = Math.max(0,this.track.scrollWidth - this.track.clientWidth);
      const current = this.track.scrollLeft;
      const stops = [...new Set(this.items.map(item => Math.min(max, Math.max(0,this.position(item)))))];
      let target;
      if(direction > 0) target = stops.find(x => x > current + 2) ?? 0;
      else target = stops.slice().reverse().find(x => x < current - 2) ?? max;
      this.track.scrollTo({ left:target, behavior:this.motion.matches ? 'auto' : 'smooth' });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if(this.dataset.autoplay !== 'true' || this.paused || this.hovered || this.focused || this.interacting || document.hidden || this.motion.matches || this.track.scrollWidth <= this.track.clientWidth + 2) return;
      this.timer = setTimeout(() => this.move(1), Number(this.dataset.interval) || 3000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.resize?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
